import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { AccessControlService, TokenStorageService } from '../services';

export const roleAccessGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const access = inject(AccessControlService);
  const tokens = inject(TokenStorageService);
  const routePath = `${route.routeConfig?.path ?? ''}`.trim();

  if (!tokens.hasActiveSession) {
    return of(router.createUrlTree(['/signIn']));
  }

  return access.ensureLoaded().pipe(
    map(() => {
      return access.canAccessPath(routePath)
        ? true
        : router.createUrlTree([access.defaultRoute()]);
    }),
    catchError(() => {
      if (!tokens.hasActiveSession) {
        return of(router.createUrlTree(['/signIn']));
      }

      const fallbackRoute = access.defaultRoute();
      if (fallbackRoute !== '/signIn' && fallbackRoute !== `/${routePath}`) {
        return of(router.createUrlTree([fallbackRoute]));
      }

      return of(true);
    })
  );
};
